<mat-nav-list>
  <a *ngIf="!isAuth" mat-list-item routerLink="/signup" [routerLinkActive]="['active']" (click)="onClose()">
    <mat-icon>face</mat-icon>
    <span class="nav-caption">Signup</span>
  </a>
  <a *ngIf="!isAuth" mat-list-item routerLink="/login" [routerLinkActive]="['active']" (click)="onClose()">
    <mat-icon>input</mat-icon>
    <span class="nav-caption">Login</span>
  </a>

  <a *ngIf="isAuth" mat-list-item [routerLinkActive]="['active']" routerLink="/process-select" (click)="onClose()">
    <mat-icon>timelapse</mat-icon>
    <span class="nav-caption">Process Runner</span>
  </a>


  <a *ngIf="isAuth" mat-list-item routerLink="/listtrans" [routerLinkActive]="['active']" (click)="onClose()">
    <mat-icon>translate</mat-icon>
    <span class="nav-caption">Translations</span>
  </a>

  <a *ngIf="isAuth" mat-list-item [routerLinkActive]="['active']" routerLink="/listdealers" (click)="onClose()">
    <mat-icon>supervisor_account</mat-icon>
    <span class="nav-caption">Dearlers</span>
  </a>
  <a *ngIf="isAuth" mat-list-item routerLink="admaker" [routerLinkActive]="['active']" [queryParams]="{ themetype: 'custom' }" (click)="onClose()">
    <mat-icon>
      manage_accounts
    </mat-icon>
    <span class="nav-caption">Client Themes</span>
  </a>

  <a *ngIf="isAuth" mat-list-item routerLink="admaker" [routerLinkActive]="['active']" [queryParams]="{ themetype: 'default' }" (click)="onClose()">
    <mat-icon>settings_suggest</mat-icon>
    <span class="nav-caption">Themes</span>
  </a>


  <a *ngIf="isAuth" mat-list-item [routerLinkActive]="['active']" routerLink="/processlog" (click)="onClose()">
    <mat-icon>summarize</mat-icon>
    <span class="nav-caption">Missing Translations</span>
  </a>
  <a *ngIf="isAuth" mat-list-item [routerLinkActive]="['active']" routerLink="/processlogclie" (click)="onClose()">
    <mat-icon>badge</mat-icon>
    <span class="nav-caption">Missing Translations(Clientwise)</span>
  </a>

  <a *ngIf="isAuth" mat-list-item [routerLinkActive]="['active']" routerLink="/missingField" (click)="onClose()">
    <mat-icon>badge</mat-icon>
    <span class="nav-caption">Missing Fields</span>
  </a>

  <a *ngIf="isAuth" mat-list-item [routerLinkActive]="['active']" routerLink="/missingFieldClient" (click)="onClose()">
    <mat-icon>badge</mat-icon>
    <span class="nav-caption">Missing Fields (Clientwise)</span>
  </a>

  <a *ngIf="isAuth" mat-list-item [routerLinkActive]="['active']" routerLink="/manageSeedKeywords/auc" (click)="onClose()">
    <mat-icon>supervisor_account</mat-icon>
    <span class="nav-caption">
     AUC Manage Seed Keywords
    </span>
  </a>

  <a *ngIf="isAuth" mat-list-item [routerLinkActive]="['active']" routerLink="/manageSeedKeywords/anc" (click)="onClose()">
    <mat-icon>supervisor_account</mat-icon>
    <span class="nav-caption">
     ANC Manage Seed Keywords
    </span>
  </a>
  <a *ngIf="isAuth" mat-list-item [routerLinkActive]="['active']" routerLink="/managestandardKey" (click)="onClose()">
    <mat-icon>supervisor_account</mat-icon>
    <span class="nav-caption">
      Manage Standard Keywords
    </span>
  </a>

  <a *ngIf="isAuth" mat-list-item [routerLinkActive]="['active']" routerLink="/AncSettings" (click)="onClose()">
    <mat-icon>supervised_user_circle</mat-icon>
    <span class="nav-caption">Anc Settings</span>
  </a>


  <mat-list-item>
    <button mat-icon-button (click)="onLogout()" *ngIf="isAuth">
      <mat-icon>eject</mat-icon>
      <span class="nav-caption">Logout</span>
    </button>
  </mat-list-item>
</mat-nav-list>
